import React from 'react'
import { Button } from '@mui/material'

const PrimaryButton = ({children, width, color, borderRadius, disabled, height, onClick, type}) => {
  return (
    <Button 
      size='small' 
      disabled={disabled} 
      variant='contained' 
      sx={{
        fontSize:'14px',
        fontWeight:'bold',
        backgroundColor: '#E598AC',
        height: height,
        width: width,
        color: color,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: borderRadius,
        '&:hover': {
          backgroundColor: '#E598AC' 
        }
      }} 
      onClick={onClick}
      type={type}
    >
      {children}
    </Button>
  )
} 

export default PrimaryButton;
